<template>
    <div class="side-panel" :class="{ isClosed: isClosed }">
        <img
            class="side-panel__close"
            src="@/assets/side-panel-close.webp"
            alt=""
            @click="isClosed = true"
        />
        <div class="side-panel__content-view fs-12">
            <h3 class="side-panel__header">
                {{ $t(`${TRANSLATION_KEY}.awardWinningBroker`) }}
            </h3>
            <div class="side-panel__cuffs">
                <span v-if="!isDarkMode">
                    <img
                        v-if="UtilityHelper.getLocale() == Locale.PL"
                        src="@/assets/cuffs_pl.png"
                        alt="Invest Cuffs 2023"
                    />
                    <img
                        v-else
                        src="@/assets/cuffs_en.png"
                        alt="Invest Cuffs 2023"
                    />
                </span>
                <span v-else>
                    <img
                        v-if="UtilityHelper.getLocale() == Locale.PL"
                        src="@/assets/cuffs_pl_white.png"
                        alt="Invest Cuffs 2023"
                    />
                    <img
                        v-else
                        src="@/assets/cuffs_en_white.png"
                        alt="Invest Cuffs 2023"
                    />
                </span>
            </div>
            <ul>
                <li v-for="item in visibleItems" :key="item.key">
                    <img src="@/assets/side-panel-checkmark.png" alt="" />{{
                        $t(`${TRANSLATION_KEY}.${item.key}`)
                    }}
                </li>
            </ul>
            <div
                v-if="
                    !UtilityHelper.isOandaPath() &&
                    UtilityHelper.getLocale() == Locale.PL
                "
                class="side-panel__broker-grid"
            >
                <img src="@/assets/tms-side-panel-1-pl.svg" alt="" />
                <img src="@/assets/tms-side-panel-2-pl.svg" alt="" />
            </div>
            <div
                v-if="
                    !UtilityHelper.isOandaPath() &&
                    UtilityHelper.getLocale() != Locale.PL
                "
                class="side-panel__broker-grid"
            >
                <img src="@/assets/tms-side-panel-1-en.svg" alt="" />
                <img src="@/assets/tms-side-panel-2-en.svg" alt="" />
            </div>
            <div
                v-if="UtilityHelper.isOandaPath()"
                class="side-panel__broker-grid"
            >
                <img src="@/assets/oanda-side-panel-1-en.svg" alt="" />
                <img src="@/assets/oanda-side-panel-2-en.svg" alt="" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { Locale } from '@/constants/locale';

export default defineComponent({
    name: 'SidePanel',
    setup() {
        const store = useStore();
        const isDarkMode = ref(false);
        const isClosed = ref(true);
        const TRANSLATION_KEY = 'SidePanel';

        const checkBody = () => {
            const body = document.querySelector('body');
            setTimeout(() => {
                if (body && body.classList.contains('auto-dark-theme')) {
                    isDarkMode.value = true;
                }
            }, 100);
        };

        const isLocked = computed(() => store.state.isLocked);
        const isEs = computed(() => UtilityHelper.getLocale() === Locale.ES);
        const isPl = computed(() => UtilityHelper.getLocale() === Locale.PL);

        const allItems = [
            { key: 'text1', hideForPl: true },
            { key: 'text2' },
            { key: 'text3', hideForEs: true },
            { key: 'text4' },
            { key: 'text5' },
            { key: 'text6', hideForEs: true },
            { key: 'text7', hideForEs: true },
        ];

        const visibleItems = computed(() =>
            allItems.filter((item) => {
                if (item.hideForPl && isPl.value) return false;
                if (item.hideForEs && isEs.value) return false;
                return true;
            })
        );

        onMounted(() => {
            checkBody();
            const SidePanelInterval = setInterval(() => {
                if (!isLocked.value) {
                    clearInterval(SidePanelInterval);
                    setTimeout(() => {
                        isClosed.value = false;
                    }, 2000);
                }
            }, 100);
        });

        return {
            Locale,
            TRANSLATION_KEY,
            isDarkMode,
            isClosed,
            UtilityHelper,
            isLocked,
            isEs,
            visibleItems,
        };
    },
});
</script>

<style lang="scss" scoped>
.side-panel {
    position: fixed;
    right: 0;
    top: 0;
    width: 400px;
    border-left: 1px solid #dddee3;
    padding-left: 40px;
    height: 100%;
    flex-direction: column;
    display: flex;
    overflow-y: auto;
    right: 0;
    transition: all 0.8s ease-in-out;
    background: #fff;

    &.isClosed {
        right: -400px;
    }

    @media (max-width: 1250px) {
        display: none;
    }

    &__content {
        width: 320px;
        margin-top: 12px;
        padding-bottom: 100px;
    }

    &__content-view {
        padding-right: 20px;
    }

    &__close {
        width: 50px;
        height: 50px;
        cursor: pointer;
        margin: 10px 10px 0 auto;
    }

    &__header {
        font-size: 20px;
        line-height: 1.5;
        margin-bottom: 20px;
        text-align: center;
    }

    &__cuffs {
        display: flex;
        justify-content: center;
        img {
            height: 85px;
            margin-bottom: 20px;
        }
    }

    ul {
        list-style: none;
        margin-bottom: 65px;
        li {
            font-size: 13px;
            display: flex;
            align-items: top;
            gap: 11px;
            img {
                width: 18px;
                height: 18px;
            }
            &:not(:last-of-type) {
                margin-bottom: 25px;
            }
        }
    }

    &__broker-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        img {
            width: 86px;
            height: 109px;
            display: flex;
            &:nth-of-type(odd) {
                margin-left: auto;
            }
            &:nth-of-type(even) {
                margin-right: auto;
            }
        }
    }
}
</style>
